<template>
  <div class="edit-aisearch">
    <mdb-card>
      <mdb-card-header class="pt-4 indigo">
        <mdb-card-title class="text-white"><strong>{{ $t("aisearch_prompts") }}</strong></mdb-card-title>
      </mdb-card-header>
      <mdb-card-body v-if="loadReady">
        <mdb-row class="mt-3">
          <mdb-col md="12">
            <p class="h6 text-muted">{{ $t("aisearch_prompts_content") }}</p>
          </mdb-col>
        </mdb-row>
        <mdb-row class="mt-3">
          <mdb-col md="12">
            <mdb-input
              v-model="aisearch.setupprompt"
              type="textarea"
              :rows="6"
              icon="robot"
              :label="$t('aisearch_setupprompt')"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="12">
            <mdb-input
              v-model="aisearch.explanationprompt"
              type="textarea"
              :rows="6"
              icon="comment"
              :label="$t('aisearch_explanationprompt')"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="12">
            <mdb-input
              v-model="aisearch.distanceprompt"
              type="textarea"
              :rows="5"
              icon="map-marker"
              :label="$t('aisearch_distanceprompt')"
            />
          </mdb-col>
        </mdb-row>
        <mdb-row>
          <mdb-col md="12">
            <mdb-btn @click="save" color="indigo" class="white-text" icon="paper-plane">
              {{ $t("save") }}
            </mdb-btn>
          </mdb-col>
        </mdb-row>
      </mdb-card-body>
    </mdb-card>
  </div>
</template>

<script>
import {
  mdbRow, mdbCol, mdbInput, mdbBtn,
  mdbCard, mdbCardBody, mdbCardHeader, mdbCardTitle,
} from "mdbvue";

export default {
  name: "EditAISearchPrompts",
  components: { mdbRow, mdbCol, mdbInput, mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbCardTitle },
    data() {
    return {
      path: "/1.0/front/aisearch",
      aisearch: { id: 0, setupprompt: "", explanationprompt: "", distanceprompt: "" },
      loadReady: false,
    };
  },
  methods: {
    load() {
      this.$http
        .get(this.path)
        .then((response) => {
          if (response.status === 200) {
            this.aisearch = response.data;
            this.loadReady = true;
          } else if (response.status === 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => console.log(error));
    },
    save() {
      this.postData = {
        id: this.aisearch.id,
        sessionid: this.$store.getters.getToken,
        setupprompt: this.aisearch.setupprompt,
        explanationprompt: this.aisearch.explanationprompt,
        distanceprompt: this.aisearch.distanceprompt,
      };
      this.$http
        .post(this.path, JSON.stringify(this.postData))
        .then((response) => {
          if (response.status === 200) {
            this.$notify.success({
              message: this.$t("aisearch_save_success"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          } else {
            this.$notify.error({
              message: this.$t("aisearch_save_error"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutshort,
            });
          }
        })
        .catch((error) => {
          this.$notify.error({
            message: this.$t("aisearch_save_error"),
            position: "top right",
            timeOut: this.$store.state.notifytimeoutshort,
          });
          console.log(error);
        });
    },
  },
  mounted() {
    this.load();
  },
};
</script>